import React from 'react';

export default function PhaseBackWarning() {
  return (
    <va-alert data-testid="phase-back-warning" status="warning" slim>
      Your claim was temporarily moved back to this step for further processing.
    </va-alert>
  );
}
